export const prepareLinkDomainLanguageAlias = (url: string, language: string, alias: string): string => {
    const correctUrl = url.endsWith('/') ? url : `${url}/`;
    const correctAlias = alias.startsWith('/') ? alias : `/${alias}`;
    return `${correctUrl}${language}${correctAlias}`;
};
